import { render, staticRenderFns } from "./Kementerian.vue?vue&type=template&id=7cdbaa18&"
import script from "./Kementerian.vue?vue&type=script&lang=js&"
export * from "./Kementerian.vue?vue&type=script&lang=js&"
import style0 from "./Kementerian.vue?vue&type=style&index=0&id=7cdbaa18&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports